import type { FC } from 'react';
import TransferIcon from '@material-ui/icons/LocalTaxiOutlined';
import TrashIcon from '@material-ui/icons/DeleteOutlined';
import { IconButton } from '@material-ui/core';
import { TransferInput } from '../../Forms/TransferForm/types';

interface Props {
  transfer: TransferInput;
  onDelete?: (id: string) => void;
  onEdit?: () => void;
}

const TransferSummaryItem: FC<Props> = ({ transfer, onDelete, onEdit }) => {
  const handleDelete = () => {
    if (transfer.id) {
      onDelete?.(transfer.id);
    }
  };
  return (
    <div onClick={onEdit} className="flex items-top justify-between px-3 py-2 hover:bg-gray-50 hover:cursor-pointer">
      <div className="flex items-top">
        <TransferIcon className="text-blue-800 mr-4 mt-1" />
        <div>
          <div className="font-bold">{transfer.company}</div>
          <div className="text-xs text-grey-500">
            <span>Pickup: {transfer.dates[0].toLocaleDateString()}</span>
          </div>
          {transfer.dates[1] ? (
            <div className="text-xs text-grey-500 space-x-1">
              <span>Return: {transfer.dates[1].toLocaleDateString()}</span>
            </div>
          ) : null}
        </div>
      </div>
      {onDelete && (
        <div>
          <IconButton
            aria-label="delete"
            size="small"
            className="mt-1"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            <TrashIcon className="text-red-500" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default TransferSummaryItem;
